// Reconciles the in-flight assistant turn with a stream failure (a thrown
// SSE `error` event, or a mid-stream network drop) in HelpChatPanel.js's
// send(). Pulled out as a pure function so the exact regression - a
// truncated-but-nonempty reply silently rendering as a complete, unmarked
// answer - has a test that doesn't require mounting the component (this
// repo has no component-test harness).
//
// Two distinct cases:
//   - No content streamed yet: replace with the error message, same as
//     before this file existed.
//   - Partial content streamed: KEEP it (it's real, and often useful) but
//     mark it truncated so the UI can show a visibly different, non-final
//     state instead of a reply that looks complete when it isn't (a bug
//     caught in review - a half-finished answer about a client's matches or
//     a listing's demand read as finished had no visual difference).
export function applyStreamFailure(lastMessage, errorMessage) {
  if (!lastMessage || lastMessage.role !== "assistant") return lastMessage;
  if (!lastMessage.content) {
    return { ...lastMessage, content: errorMessage };
  }
  return { ...lastMessage, truncated: true, truncatedMessage: errorMessage };
}
